import { render, staticRenderFns } from "./create.vue?vue&type=template&id=2e56fc26&scoped=true"
import script from "./create.vue?vue&type=script&lang=js"
export * from "./create.vue?vue&type=script&lang=js"
import style0 from "./create.vue?vue&type=style&index=0&id=2e56fc26&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e56fc26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-servicesplatform-fe/treasurenet-tnservices-servicesplatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e56fc26')) {
      api.createRecord('2e56fc26', component.options)
    } else {
      api.reload('2e56fc26', component.options)
    }
    module.hot.accept("./create.vue?vue&type=template&id=2e56fc26&scoped=true", function () {
      api.rerender('2e56fc26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/governance/proposal/create.vue"
export default component.exports